// Production Device Group Item
//
// Extends Device Group Item js/views/device_group_item.js
//
// Should be extended to show particular Device Group Types
// unless the basic default handling happens below.
//
// ex: public/js/views/production_devicegroup_item.js
//
// Would like to make this file more like a Vue project.
//


// Item view for a Production Device Group

import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DeviceGroupItemMixin from '@/views/list_item/device_group_item';
import template from '@/views/list_item/device_group_item_template';

const globalCh = Radio.channel('global');
const apiCh = Radio.channel('api');

var ProductionDeviceGroupItemView = Marionette.View.extend(DeviceGroupItemMixin).extend({
    ui: {
        name: '.name',
        draft_code: '.action.draft-code',
        code_history: '.action.code-history',
        deploy: '.action.deploy',
        delete: '.action.delete',
        settings: '.action.settings',
        devices: '.action.devices,.devices-link',
        go_live: '.action.go-live',
        go_live_region: '.go-live-region',
        tooltips: '[data-toggle="tooltip"]',
        expando: '.expando',
        retracto: '.retracto'
    },
    regions: {
        devicegroup_info: '.devicegroup-info',
        devicecount_info: '.devicecount-info',
        deployment_info: '.deployment-info',
        last_deployed_info: '.last-deployed-info',
        relationships_region: '.relationships-region',
        go_live_region: '.go-live-region'
    },
    events: {
        'click @ui.name': 'show_dashboard',
        'click @ui.draft_code': 'show_draft_code',
        'click @ui.code_history': 'show_code_history',
        'click @ui.deploy': 'show_deployment_dialog',
        'click @ui.delete': 'show_delete_dialog',
        'click @ui.settings': 'show_settings_dialog',
        'click @ui.devices': 'show_devices',
        'click @ui.expando': 'expand',
        'click @ui.retracto': 'retract',
    },
    initialize: function() {
        this.render_device_group_info = DeviceGroupItemMixin.render_device_group_info;
    },
    template: Handlebars.compile(template),
    attributes: function() {
        return {
            "data-id" : this.model.id,
        };
    },
    templateContext: function (options) {
        let active = globalCh.request('active_account');
        let primary = globalCh.request('primary_account');
        let icon = 'ei-icon-' + this.model.type;
        let show_actions = true;
        let show_devices = false;
        let show_draft = false;
        let show_code_history = false;
        let show_edit = false;
        let show_delete = false;
        let show_deploy = false;
        let show_settings = false;
        let show_test_zone = false;
        if (this.getOption('show_actions') == false) show_actions = false;
        if (this.model.type === 'pre_production_devicegroup') {
            show_devices = active.permits(primary, 'view_pre_production_devices');
            show_draft = active.permits(primary, 'view_pre_production_code');
            show_code_history = active.permits(primary, 'view_pre_production_deployments');
            show_edit = active.permits(primary, 'update_pre_production_devicegroup');
            show_delete = active.permits(primary, 'delete_pre_production_devicegroup');
            show_deploy = active.permits(primary, 'update_pre_production_devicegroup');
            show_test_zone = active.permits(primary, 'view_pre_production_devicegroups');
            show_settings = active.permits(primary, 'update_pre_production_devicegroup');
        } else if (this.model.type === 'production_devicegroup') {
            show_devices = active.permits(primary, 'view_production_devices');
            show_code_history = active.permits(primary, 'view_production_deployments');
            show_edit = active.permits(primary, 'update_production_devicegroup');
            show_delete = active.permits(primary, 'delete_production_devicegroup');
            show_deploy = active.permits(primary, 'update_production_devicegroup');
            show_test_zone = active.permits(primary, 'view_pre_production_devicegroups');
            show_settings = active.permits(primary, 'update_production_devicegroup');
        }

        return {
            icon: icon,
            show_actions: show_actions,
            show_draft: show_draft,
            show_code_history: show_code_history,
            show_edit: show_edit,
            show_devices: show_devices,
            show_delete: show_delete,
            show_deploy: show_deploy,
            show_settings: show_settings,
            show_test_zone: show_test_zone,
            expandable: this.getOption('expandable'),
            relationship_type: this.getOption('relationship_type')
        };
    },
    onRender: function() {
        this.ui.retracto.hide();
        this.ui.tooltips.tooltip();
        this.render_device_group_info();
        this.listenTo(this.model, 'change', this.render);
    }, 
    className: function(){
        if ( this.getOption('expandable') ) { 
            return 'section';
        }
        return 'section full';
    },
    // ACTIONS
    show_settings_dialog: function(e) {
        e.stopPropagation();
        globalCh.request('show_production_device_group_settings_dialog', this.model, this.model.type);
    },
    show_dashboard: function(e) {
        e.stopPropagation();
        if (e.which === 1) {
            globalCh.request('show_devicegroup_dashboard', this.model, this.model.rel.get('product'));
            return false;
        }
    },
    show_draft_code: function (e) {
        e.stopPropagation();
        var draft = this.model.draft;
        var devicegroup = this.model;
        
        globalCh.request('showCodeEditor', draft, devicegroup);
    },
    show_code_history: function (e) {
        e.stopPropagation();
        globalCh.request('show_devicegroup_code_history',
                                    this.model,
                                    this.model.rel.get('product'));
    },
    show_delete_dialog: function (e) {
        e.stopPropagation();
        globalCh.request('show_delete_devicegroup_dialog', this.model);
    },
    show_deployment_dialog: function () {
            globalCh.request('show_create_deployment_dialog', this.model);
    },
    show_devices: function (e) {
        e.stopPropagation();
        let devicegroups = apiCh.request('development_devicegroup');
        if (this.model.type === devicegroups.TYPES_MAP.production) {
            globalCh.request('show_production_devices', this.model);
        } else if (this.model.type === devicegroups.TYPES_MAP.pre_production) {
            globalCh.request('show_pre_production_devices', this.model);
        }
    },
});

export default ProductionDeviceGroupItemView;

